import { render, staticRenderFns } from "./Question16.vue?vue&type=template&id=33093362&scoped=true&"
import script from "./Question16.vue?vue&type=script&lang=js&"
export * from "./Question16.vue?vue&type=script&lang=js&"
import style0 from "./Question16.vue?vue&type=style&index=0&id=33093362&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33093362",
  null
  
)

export default component.exports